import { useEffect, useState } from "react";

type FontSize = "smaller" | "small" | "default" | "large" | "larger";

const FONT_SIZE_STORAGE_KEY = "istari-font-size-preference";

const FONT_SIZE_OFFSET_MAP = {
  smaller: "-2px",
  small: "-1px",
  default: "0px",
  large: "1px",
  larger: "2px",
} as const;

export function useFontSize() {
  const [fontSize, setFontSize] = useState<FontSize>("default");

  // Apply font size to DOM
  const applyFontSize = (size: FontSize) => {
    if (typeof window !== "undefined") {
      const offset = FONT_SIZE_OFFSET_MAP[size];
      document.documentElement.style.setProperty("--font-offset", offset);
    }
  };

  // Initialize font size on mount
  useEffect(() => {
    // Load saved preference or default
    const savedFontSize = localStorage.getItem(FONT_SIZE_STORAGE_KEY) as FontSize | null;
    const initialFontSize = savedFontSize || "default";
    setFontSize(initialFontSize);
    applyFontSize(initialFontSize);
  }, []);

  // Update font size when state changes
  useEffect(() => {
    localStorage.setItem(FONT_SIZE_STORAGE_KEY, fontSize);
    applyFontSize(fontSize);
  }, [fontSize]);

  return {
    fontSize,
    setFontSize,
  };
}
